import React, { useEffect, useState,useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { formatDateToShortString } from "../../../../common/common";

export default function OrderHistoryModal({ isOpen, onClose, orderDetailsId,orderInfo }) {
  const [orderResponse, setOrderResponse] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState('');
  // const [currentPage, setCurrentPage] = useState(1);
  const [loadingdata, setLoadingdata] = useState(false)
  // const [uniqueProducts, setUniqueProducts] = useState(orderInfo.uniqueProducts)
  // const [totalProductsQuantity, setTotalProductsQuantity] = useState(orderInfo.uniqueProducts)
  const typingTimeoutRef = useRef(null);

  const navigate = useNavigate()
  const itemsPerPage = 10;
  const [page, setPage] = useState(1);
  const [limit,setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  const getCategoryNames = (orderCategory) => {
    if (!Array.isArray(orderCategory) || orderCategory.length === 0) return "N/A";
  
    return orderCategory.map(cat => cat.cateName || "Unknown").join(", ");
  };

  const getOrderOld = async () => {
    try {
      setLoadingdata(true);
  
      const response = await fetch(`${process.env.REACT_APP_ORDER_LIST_BY_STOREID}?order_details_id=${orderDetailsId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.detail?.isExpireToken) {
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          navigate("/login");
        }
        throw new Error(errorData.detail?.message || "Failed to fetch orders");
      }
  
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let received = "";
      let done = false;
  
      while (!done) {
        const { value, done: doneReading } = await reader.read();
        done = doneReading;
        if (value) {
          received += decoder.decode(value, { stream: true });
        }
      }
      // Stream finished, received me pura JSON string aa chuka hai
      const data = JSON.parse(received);
  
      const uniqueSkus = new Set(data.data.map(item => item.sku));
      const uniqueProductCount = uniqueSkus.size;
  
      // setUniqueProducts(uniqueProductCount);
      setOrderResponse(data.data);
      setFilteredOrders(data.data);
  
    } catch (err) {
      toast.error(err.message, {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoadingdata(false);
    }
  };




  const getOrder = async () => {
    try {
      setLoadingdata(true);
      
      let url = `${process.env.REACT_APP_ORDER_LIST_BY_STOREID}?order_details_id=${orderDetailsId}&page=${page}&limit=${limit}`;
      if (searchTerm.trim()) {
        url += `&search=${encodeURIComponent(searchTerm)}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      
      const data = await response.json();
      if (!response.ok) {
        if (data.detail.isExpireToken) {
          const token = localStorage.removeItem("token");
          const user = localStorage.removeItem("userInfo");
          navigate("/login")
        }
        throw new Error(data.detail?.message || 'Failed to fetch orders');
      }
      // const uniqueSkus = new Set(data.data.map(item => item.sku));
      // const uniqueProductCount = uniqueSkus.size;
      // if(uniqueProducts == ""){
      //   setUniqueProducts(data.unique_products)
      // }
      // if(totalProductsQuantity == ""){
      //   setTotalProductsQuantity(data.total_product_quantity)
      // }
      setOrderResponse(data.data);
      setFilteredOrders(data.data);
      setTotal(data.total);  // Total count for pagination
      setPage(data.page);    // Current page
      setLimit(data.limit);  // Current limit
    } catch (err) {
      toast.error(err.message, {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoadingdata(false)
    }
  };
  

  useEffect(() => {
    if (isOpen) {
      getOrder();
    }
  }, [page,debouncedSearch]);

  // 🔍 Filter logic
  // useEffect(() => {
  //   const lowerSearch = searchTerm.toLowerCase();
  //   const filtered = orderResponse.filter(order =>
  //     order.order_id?.toString().includes(lowerSearch) ||
  //     order.sku?.toLowerCase().includes(lowerSearch) ||
  //     order.product_name?.toLowerCase().includes(lowerSearch) ||
  //     order.product_title?.toLowerCase().includes(lowerSearch)
  //   );
  //   setFilteredOrders(filtered);
  //   // setCurrentPage(1); // reset page on new search
  // }, [searchTerm, orderResponse]);

  // const paginatedOrders = filteredOrders.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const totalPages = Math.ceil(total / limit);


  const getPaginationRange = () => {
    const totalVisible = 5;
    const range = [];
    const showLeftEllipsis = page > 3;
    const showRightEllipsis = page < totalPages - 2;

    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, page + 2);

    if (page <= 3) {
      end = Math.min(5, totalPages);
    } else if (page >= totalPages - 2) {
      start = Math.max(totalPages - 4, 1);
    }

    for (let i = start; i <= end; i++) {
      range.push(i);
    }

    return { range, showLeftEllipsis, showRightEllipsis };
  };

// 🟡 Debounce the search term (500ms)
useEffect(() => {
  if (typingTimeoutRef.current) {
    clearTimeout(typingTimeoutRef.current);
  }

  typingTimeoutRef.current = setTimeout(() => {
    setDebouncedSearch(searchTerm); // trigger search
    setPage(1); // reset page on new search
  }, 500);

  return () => clearTimeout(typingTimeoutRef.current);
}, [searchTerm]);


  const { range: paginationRange, showLeftEllipsis, showRightEllipsis } = getPaginationRange();

  if (!isOpen) return null;

  return (
    <div className="fixed w-full inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center">

      <div className="bg-white w-full max-w-6xl max-h-[90vh] rounded-lg shadow-lg flex flex-col">
        {loadingdata &&
          <div className="flex items-center justify-center min-h-[200px]">
            <div className="flex flex-col items-center space-y-2">
              <div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
              <p className="text-gray-600 text-sm">Loading...</p>
            </div>
          </div>
        }

        {
          !loadingdata &&
          <>
            {/* Header */}
            < div className="p-4 border-b flex justify-between items-center">
              <h2 className="text-lg font-semibold text-gray-800">Line Items Information</h2>
              <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-xl">&times;</button>
            </div>

            {/* Stats Cards (stay fixed) */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 px-6 pt-4">
              <div className="metric-card bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                <div className="flex items-center">
                  <div className="p-3 rounded-lg bg-green-100 text-green-600 mr-4">
                    <i className="fas fa-shopping-bag text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Total Orders</p>
                    <h3 className="text-2xl font-bold">{orderInfo.noOfOrders?.toLocaleString('en-US')}</h3>
                  </div>
                </div>
              </div>
              <div className="metric-card bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                <div className="flex items-center">
                  <div className="p-3 rounded-lg bg-blue-100 text-blue-600 mr-4">
                    <i className="fas fa-reorder text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Line Items</p>
                    <h3 className="text-2xl font-bold">{orderInfo.noOfProducts.toLocaleString('en-US')}</h3>
                  </div>
                </div>
              </div>
              <div className="metric-card bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                <div className="flex items-center">
                  <div className="p-3 rounded-lg bg-red-100 text-red-600 mr-4">
                    <i className="fas fa-box-open text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Total Unique Products</p>
                    <h3 className="text-2xl font-bold">{orderInfo.uniqueProducts?.toLocaleString('en-US')}</h3>
                  </div>
                </div>
              </div>
              <div className="metric-card bg-white p-5 rounded-lg border border-gray-200 shadow-sm">
                  <div className="flex items-center">
                    <div className="p-3 rounded-lg bg-blue-100 text-blue-600 mr-4">
                      <i className="fas fa-shopping-cart text-xl"></i>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Total Products Quantity</p>
                      <h3 className="text-2xl font-bold">{orderInfo.totalProductsQuantity?.toLocaleString('en-US')}</h3>
                    </div>
                  </div>
                </div>
            </div>
            
            

            {/* Search */}
            <div className="p-4 border-b flex flex-col md:flex-row md:justify-between md:items-center space-y-2 md:space-y-0">
              {/* From & End Date */}
              <div className="flex items-center space-x-4 text-sm text-gray-600">
                <div>
                  <span className="font-medium text-gray-700">From:</span>{" "}
                  {(orderInfo.fromDate)}
                </div>
                <div>
                  <span className="font-medium text-gray-700">To:</span>{" "}
                  {(orderInfo.endDate)}
                </div>
              </div>

              {/* Search Input */}
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search by Order ID, SKU, Item Name, Title..."
                className="px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300 w-full md:w-80"
              />
            </div>

            {/* Scrollable table section */}
            <div className="overflow-y-auto flex-1">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500">Image</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500">Order ID</th>
                    {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500">Order At</th> */}
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500">SKU</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500">Name</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500">Title</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {filteredOrders.length > 0 ? filteredOrders.map((order, index) => (
                    <tr key={index}>
                      <td className="px-6 py-4 text-sm text-gray-500">
                        {order.product_image ? <img src={order.product_image} alt="product" className="w-12 h-12 object-cover rounded" /> : "—"}
                      </td>
                      <td className="px-6 py-4 text-sm font-medium text-gray-900">
                      {order.order_id}
                      <p className="text-xs text-gray-500 mt-1">{formatDateToShortString(order.order_created_at)}</p>
                      </td>
                      {/* <td className="px-6 py-4 text-sm text-gray-500">{formatDateToShortString(order.order_created_at)}</td> */}
                      <td className="px-6 py-4 text-sm text-gray-500">{order.sku}</td>
                      <td className="px-6 py-4 text-sm text-gray-900">{order.product_name}

                      <p className="text-xs text-gray-500 mt-1"><b>Size:</b> {(order.product_size ? order.product_size : "N/A")}</p>
                      <p className="text-xs text-gray-500 mt-1"><b>Color:</b> {(order.product_color? order.product_color : "N/A")}</p>

                      </td>
                      <td className="px-6 py-4 text-sm text-gray-500">{order.product_title}
                      <p className="text-xs text-gray-500 mt-1"><b>Price:</b> ${(order.selling_price ? order.selling_price : "N/A")}</p>
                      <p className="text-xs text-gray-500 mt-1">
                          <b>Categories:</b> {getCategoryNames(order.category)}
                        </p>

                      </td>
                      

                    </tr>
                  )) : (
                    <tr><td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">No Line Items Found.</td></tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t text-sm text-gray-500 flex justify-between items-center">
              <span>
              Showing <b>{((page - 1) * limit) + 1}</b> to <b>{(limit*page)}</b> of <b>{total}</b> Line Items
              </span>
              <div className="flex gap-2">
                <button
                  disabled={page === 1}
                  onClick={() => setPage(prev => prev - 1)}
                  className="px-3 py-1 border rounded-md text-sm text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-40"
                >
                  Previous
                </button>

                {showLeftEllipsis && (
                  <>
                    <button
                      onClick={() => setPage(1)}
                      className="px-3 py-1 border rounded-md text-sm bg-white text-gray-700 hover:bg-gray-50"
                    >
                      1
                    </button>
                    <span className="px-2 py-1 text-sm text-gray-500">...</span>
                  </>
                )}

                {paginationRange.map(i => (
                  <button
                    key={i}
                    onClick={() => setPage(i)}
                    className={`px-3 py-1 border rounded-md text-sm ${page === i ? "bg-indigo-600 text-white" : "bg-white text-gray-700 hover:bg-gray-50"}`}
                  >
                    {i}
                  </button>
                ))}

                {showRightEllipsis && (
                  <>
                    <span className="px-2 py-1 text-sm text-gray-500">...</span>
                    <button
                      onClick={() => setPage(totalPages)}
                      className="px-3 py-1 border rounded-md text-sm bg-white text-gray-700 hover:bg-gray-50"
                    >
                      {totalPages}
                    </button>
                  </>
                )}

                <button
                  disabled={page === totalPages}
                  onClick={() => setPage(prev => prev + 1)}
                  className="px-3 py-1 border rounded-md text-sm text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-40"
                >
                  Next
                </button>
              </div>
              
            </div>
          </>
        }


      </div>
    </div >



  );
}
